import type { ToastData } from "~types/app/toast.types";
import { createElement, Fragment, useEffect } from "react";
import { toast as showToast } from "sonner";

function toDescriptionNode(description?: string | null) {
  if (!description?.includes("\n")) return description;
  return description.split("\n").reduce<(string | ReturnType<typeof createElement>)[]>(
    (acc, line, i) =>
      i === 0 ? [line] : [...acc, createElement("br", { key: i }), line],
    []
  );
}

/** Display a toast message on component mount. */
export function useToast(toast?: ToastData | null) {
  useEffect(() => {
    if (toast) {
      setTimeout(() => {
        showToast[toast.type](toast.title, {
          id: toast.id,
          description: createElement(Fragment, null, toDescriptionNode(toast.description)),
          duration: toast.persist ? Infinity : undefined,
        });
      }, 0);
    }
  }, [toast]);
}
